import { FORM_ERROR_CLASS, FORM_LABEL_CLASS } from '@/lib/ui/input-styles'

interface FormFieldProps {
  label: string
  htmlFor?: string
  error?: string
  required?: boolean
  description?: React.ReactNode
  children: React.ReactNode
}

export function FormField({
  label,
  htmlFor,
  error,
  required,
  description,
  children,
}: FormFieldProps) {
  return (
    <div>
      <label htmlFor={htmlFor} className={FORM_LABEL_CLASS}>
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
      {description && (
        <p className="-mt-1 mb-2 text-sm text-gray-500 dark:text-gray-400">{description}</p>
      )}
      {children}
      {error && <p className={FORM_ERROR_CLASS}>{error}</p>}
    </div>
  )
}
